/**
 * @Description 选址地图相关
 */

export const markerActiveColorOption = { // 当前点击的商圈围栏
  // strokeColor: '#ff861d',
  // fillColor: 'rgba(242, 48, 48, 0.2)',
  strokeColor: '#FC7657',
  fillColor: '#FC7657',
  zIndex: 20
};


export const markerDefaultColorOption = { // 默认普通商圈围栏颜色
  strokeColor: '#006AFF',
  fillColor: '#006AFF',
  zIndex: 10
};

/**
 * @description 标签类型
 */
export enum LabelType {
  System = 1, // 系统标签
  NetPlan = 2, // 网规标签
  Custom = 3, // 自定义标签
  Mutual = 4 // 双向推荐
}

// A、B、C、D标签（网规标签）
export const labelType = [
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_A@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_B@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_C@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_D@2x.png`,
];

export const labelTypeSmall = [
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_A_small@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_B_small@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_C_small@2x.png`,
  `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/label/label_D_small@2x.png`,
];

/*
  网规标签名称与图片对应map

  使用方法：
  拿到标签名称label后，
  const imgUrl = typeLabelImgMap.get(label) || ''
*/
export const typeLabelImgMap = new Map([
  ['A类', labelType[0]],
  ['B类', labelType[1]],
  ['C类', labelType[2]],
  ['D类', labelType[3]],
]);

export const typeSmallLabelImgMap = new Map([
  ['A类', labelTypeSmall[0]],
  ['B类', labelTypeSmall[1]],
  ['C类', labelTypeSmall[2]],
  ['D类', labelTypeSmall[3]],
]);

// 区以下聚合的临界条件
export const CLUSTER_CRITICAL_COUNT = 500;
